module.exports = __webpack_public_path__ + "static/img/msg_center-icon.6a0e17d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/msg_center-icon.png
// module id = 8+jv
// module chunks = 2